// import { createAsyncThunk } from "@reduxjs/toolkit";
import { setDoc } from "firebase/firestore";
import { SignWithGoogle } from "../../../utils/auth/SignWithGoogle";

import { createAsyncThunk } from "@reduxjs/toolkit";

interface IGoogleResponse {
  userName: string | null;
  userEmail: string | null;
  userPhoto: string | null;
  token: string;
  uid: string;
}

export const signUpWithGoogle = createAsyncThunk<
  IGoogleResponse,
  void,
  { rejectValue: { message: string } }
>("auth/signUpWithGoogle", async (_, thunkAPI) => {
  try {
    const { snapShot, docRef, userData } = await SignWithGoogle();

    if (!snapShot.exists()) {
      await setDoc(docRef, userData);
    } else {
      throw new Error("User already exists");
    }

    return {
      userName: userData.fullName,
      userEmail: userData.email,
      token: userData.token,
      userPhoto: userData.photoURL,
      uid: userData.uid
    };
  } catch (error) {
    return thunkAPI.rejectWithValue({ message: "Google sign-in failed" });
  }
});
